/**
 * Unit Conversion Utilities for Engineering Fluid Mechanics
 */







export const FLOW_CONVERSIONS_TO_M3_S = {
  "L/s": 0.001,
  "m3/h": 1 / 3600,
  "L/min": 0.001 / 60,
  "gpm_us": 0.0000630901964,
  "gpm_uk": 0.0000757682,
};

export function convertFlowToM3PerSec(value, unit) {
  return value * (FLOW_CONVERSIONS_TO_M3_S[unit] || 0.001);
}

export function convertFlowFromM3PerSec(valueM3s, unit) {
  return valueM3s / (FLOW_CONVERSIONS_TO_M3_S[unit] || 0.001);
}

export function convertMmToInches(mm) {
  return mm / 25.4;
}

export function convertInchesToMm(inches) {
  return inches * 25.4;
}

export function convertMetersToFeet(meters) {
  return meters * 3.28084;
}

export function convertFeetToMeters(feet) {
  return feet / 3.28084;
}

export function convertPressureToKPa(val, unit) {
  switch (unit) {
    case "bar": return val * 100;
    case "kPa": return val;
    case "psi": return val * 6.89476;
    case "m_head": return val * 9.80665;
    case "ft_head": return val * 2.98907;
    default: return val;
  }
}

export function convertPressureFromKPa(kPa, unit) {
  switch (unit) {
    case "bar": return kPa / 100;
    case "kPa": return kPa;
    case "psi": return kPa / 6.89476;
    case "m_head": return kPa / 9.80665;
    case "ft_head": return kPa / 2.98907;
    default: return kPa;
  }
}
